import { render } from "./SideNav.vue?vue&type=template&id=0c43b2e8&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=0c43b2e8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ecommerce\\frontend_administrativo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c43b2e8"]])

export default __exports__